<template lang="pug">
div
  AppTitle.u-mb-sm(:title="$t('mantra')")
  .grid.is-desktop-6.is-tablet-8
    .column
      .helpSearch(ref="search")
        input.input(type="search" :placeholder="$t('searchPlaceholder')" v-model="query" @focus="showResults = true")
        .helpSearch-autocomplete(v-show="results.edges.length && showResults")
          AppLink(v-for="({ node }) in results.edges" :to="`/knowledgebase/${node.category.slug}/${node.slug}`" :key="node.id") {{ node.title }}
</template>

<style lang="stylus">
.helpSearch
  position: relative

  &-autocomplete
    position: absolute
    z-index: 1
    top: 100%
    left: 0
    right: 0
    background: $clWhite
    border: $border solid $clBlack
    max-height: 400px
    overflow: auto
    padding: unitRes(5, 10) 0

    >*
      display: block
      padding: unitRes(5, 10) unitRes(10, 20)
</style>

<script>
import { debounce } from 'throttle-debounce';
import { FaqsSearch } from '~/graphql/Faq.gql';

export default {
  name: 'HelpHeader',
  props: {
    category: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    query: '',
    showResults: true,
    results: {
      edges: [],
      pageInfo: {
        hasNextPage: false
      }
    }
  }),
  watch: {
    query(value) {
      if (value && value.length >= 3) {
        this.pendingQuery = value;
        const locale = /[A-Z]+/i.test(value) ? 'en' : 'ar';
        this.$fetch(value, locale);
      }
    },
    $route() {
      this.showResults = false;
    }
  },
  created() {
    this.$fetch = debounce(500, this.fetch);
  },
  mounted() {
    this.$onClickOutside = e => {
      if (e.target.closest('.helpSearch')) return;

      this.showResults = false;
    };

    document.addEventListener('click', this.$onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.$onClickOutside);
  },
  methods: {
    async fetch(query, locale) {
      try {
        const { data } = await this.$api.query({
          query: FaqsSearch,
          variables: {
            query,
            locale,
            first: 10,
            category: this.category || undefined
          }
        });

        this.results = data.faqs;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "mantra":"How can we |help you?",
    "searchPlaceholder":"Describe your issue",
    "search":"Search"
  },
  "ar": {
    "mantra":"كيف يمكننا |مساعدتك؟",
    "searchPlaceholder":"وصف المشكلة",
    "search":"بحث"
    }
}
</i18n>
